var image_upload_default = {
  "container": "f7mfn",
  "disabled": "_21n8Z",
  "imageInput": "EWXMF",
  "overlay": "_3sEEY",
  "text": "_7Zd3c",
  "shown": "immRw",
  "hide": "k0OKN",
  "spinner": "WLkZm",
  "spin": "KLMTB"
};
export {
  image_upload_default as default
};
//# sourceMappingURL=image-upload-scss.js.map
